import React from "react";
import { Iconfont } from "../../../../components/icon/iconfont";
import { useSelector,useDispatch } from "react-redux";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"
import { saveWishListProduct as  apiAddToWishList, removeWishListProduct as apiRemoveFromWishList} from '../../../../../api'
import GeekoEvents from '../../../../ads/events'
import { action_fetch_wish_list, setWishList } from '../../../../../store/actions/global'
import { TOGGLE_UI_LOGIN } from "../../../../../store/actions/ui";

export default props =>{
    useStyles(classes)
    const { productId, product_type } = props
	const dispatch = useDispatch()
    const global = useSelector((state) => state.global)
	const { wishlist } = global
	const hasExistInWishList = wishlist?.some(pid => pid === productId)

	const addToWishList = async () => {
		if(hasExistInWishList){
			dispatch(setWishList(wishlist?.filter(w => w !== productId)))
			await apiRemoveFromWishList(productId)
		}else{
			dispatch(setWishList([...(wishlist||[]), productId]))
			const response = await apiAddToWishList(productId)
			if (response?.code === 300) {
				// window.location.href = `/i/login?redirectUrl=${window.location.href}`
				dispatch({
                    type: TOGGLE_UI_LOGIN,
                    payload: {
                        showLogin:true,
						eventType:"收藏页"
                    }
                });
			} else if(response?.code != 200){
				if(response?.result){
					alert(response?.result)
				} else {
					console.error(response)
				}
			}
			GeekoEvents.addToWishList({
				productId,
				product_type
			})
		}
		// dispatch(action_fetch_wish_list())
	}

    return (
        <span  className={`${classes.Wish} ${hasExistInWishList?classes.Active:''} ${props?.className?props.className:""}`} onClick={addToWishList}>
            <Iconfont style={{...props?.style}}>&#xe631;</Iconfont>
        </span>
    )
}